import { Fade, IconButton, Modal } from '@material-ui/core'
import { Close } from '@material-ui/icons'

interface Props {
  children: React.ReactNode
  showModal: boolean
  setShowModal: (value: boolean) => void
  variant?: string
  title: string
  disableBackdropClick?: boolean
}

const ModalPopUp = ({
  children,
  showModal,
  setShowModal,
  variant,
  title,
  disableBackdropClick = false,
}: Props) => {
  return (
    <Modal
      open={showModal}
      onClose={(event, reason) => {
        if (!disableBackdropClick || reason !== 'backdropClick') {
          setShowModal(false)
        }
      }}
    >
      <Fade in={showModal}>
        <div className={`modal-window ${variant}`}>
          <div className="modal-header">
            <div>{title}</div>
            <IconButton onClick={() => setShowModal(false)}>
              <Close />
            </IconButton>
          </div>
          <div className="modal-body">{children}</div>
        </div>
      </Fade>
    </Modal>
  )
}

export default ModalPopUp
